module.exports = __webpack_public_path__ + "static/img/eight.3afcc64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eight.png
// module id = 631f
// module chunks = 1